import fetch from '../../lib/wrappedFetch'
import config from '../../config'

class CalendarsService {
  fetchCalendars = (params) => {
    return fetch(config.config.endpointUrls.fetchCalendars(params), {
      method: 'GET'
    })
  }
  fetchCalendar = (params) => {
    return fetch(config.config.endpointUrls.fetchCalendar(params), {
      method: 'GET'
    })
  }
  createCalendar = (fields) => {
    return fetch(config.config.endpointUrls.createCalendar(), {
      method: 'POST',
      body: fields
    })
  }
  updateCalendar = ({ id, ...fields }) => {
    return fetch(config.config.endpointUrls.updateCalendar({ id }), {
      method: 'PATCH',
      body: fields
    })
  }
}

export default new CalendarsService()



// WEBPACK FOOTER //
// ../src/services/calendarsService/calendarsService.js